import _get from 'lodash/get';
/* @ngInject */
export default class EmulatorBatteryStatusController {
    constructor(
        EventEmitter,
    ) {
        this.EventEmitter = EventEmitter;
        this.batteryStates = [
            { value: "OK", label: "OK" },
            { value: "LOW", label: "Low" },
            { value: "CRITICAL", label: "Critical" },
            { value: "UNKNOWN", label: "Unknown" }
        ];
    }


    $onInit() {
        this.event = {
            batteryStatus: {
                percentage: _get(this.device, "reported.batteryStatus.percentage", 100),
                state: _get(this.device, "reported.batteryStatus.state", "OK"),
                estimatedRemainingYears: _get(this.device, "reported.batteryStatus.estimatedRemainingYears", 0)
            }
        }
    }

    sendEvent() {
        this.onPublishEvent(
            this.EventEmitter({
                event: this.event
            })
        );
    }
}